import { render, staticRenderFns } from "./AddprojectDocumentModal.vue?vue&type=template&id=e4347324"
import script from "./AddprojectDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddprojectDocumentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports